/* eslint-disable react/no-unescaped-entities */
import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BodyM, HeadlineXL } from '@sorare/core/src/atoms/typography';
import { useScreenSize } from '@sorare/core/src/hooks/device/useScreenSize';
import { laptopAndAbove } from '@sorare/core/src/style/mediaQuery';

import history from '#src/Careers/assets/history.webp';
import {
  ImageSection,
  Img,
  StyledContainer,
  TwoColumnsContainer,
} from '#src/Careers/ui.tsx';

const HistorySection = styled(ImageSection)`
  @media ${laptopAndAbove} {
    background-image: url(${history});
    background-size: cover;
    background-position: top;
    background-repeat: no-repeat;
  }
`;

const StyledImg = styled(Img)`
  object-fit: contain;
  object-position: top;
  height: auto;
  width: 100%;
  aspect-ratio: 1800 / 1093;
`;

export const History = () => {
  const { up: isLaptop } = useScreenSize('laptop');

  return (
    <>
      {!isLaptop && (
        <StyledImg
          src={history}
          alt="Sorare's history"
          height={1093}
          width={1800}
        />
      )}
      <HistorySection vAlignContent="center">
        <StyledContainer>
          <TwoColumnsContainer image="left">
            {!!isLaptop && <div />}
            <Vertical gap={3}>
              <HeadlineXL>Sorare's history</HeadlineXL>
              <BodyM>
                Founded in 2018, Sorare was created by football fans for
                football fans – and in short order has partnered with the
                globe's biggest football clubs (300+) while amassing more than 3
                million Managers across nearly every country in the world. In
                2022, Sorare expanded into baseball and basketball via exclusive
                partnerships with MLB and the NBA, respectively.
              </BodyM>
            </Vertical>
          </TwoColumnsContainer>
        </StyledContainer>
      </HistorySection>
    </>
  );
};
